module.exports = __webpack_public_path__ + "img/sjb5_63_100.prt.9318a70e.jpg";